/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  // Abratel customization — move a conversation to another Channel::Api inbox.
  // Goes through the whatsapp-panel which has the SQL access to flip
  // conversation.inbox_id + contact_inbox_id (Chatwoot's API doesn't expose it).
  // Panel's requireAuth accepts the user's Chatwoot access_token via X-CW-Token
  // header — sending it explicitly works whether the user has logged into the
  // panel previously or not.
  transferInbox(accountId, conversationId, targetInboxId, accessToken) {
    return axios.post(
      `/_panel/api/conversations/${accountId}/${conversationId}/transfer-inbox`,
      { target_inbox_id: targetInboxId },
      {
        withCredentials: true,
        headers: accessToken ? { 'X-CW-Token': accessToken } : {},
      }
    );
  }

  getUnreadCounts() {
    return axios.get(`${this.url}/unread_counts`);
  }
}

export default new ConversationApi();
